<template>
  <div class="blocked-page" v-if="display">
    <!-- Top Bar -->
    <div class="top-bar">
      <button class="icon-button" @click="close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </button>
      <h1 class="page-title">Blocked accounts</h1>
      <div class="spacer"></div>
    </div>

    <!-- Content -->
    <div class="content">
      <!-- Empty State -->
      <div class="empty-state" v-if="blockedAccounts.length === 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="23" y1="9" x2="17" y2="9"/>
        </svg>
        <p>No blocked accounts</p>
      </div>

      <!-- Blocked List -->
      <div class="blocked-list" v-else>
        <div class="blocked-item" v-for="account in blockedAccounts" :key="account.id">
          <div class="blocked-info">
            <p class="blocked-username">{{ account.name }}</p>
          </div>

          <button class="unblock-button" @click="unblock(account,this)">
            Unblock
          </button>
        </div>
      </div>
    </div>
    <Loader :loading="loading"/>
  </div>
</template>

<script>
import Loader from "@/views/components/loader/Loader.vue"

export default {
  name: 'BlockedAccounts',
  components:{
    Loader
  },
  data() {
    return {
      loading:false,
      display: false,
      blockedAccounts: []
    }
  },
  methods: {
    show(inf) {
      this.display = true;
      this.blockedAccounts = inf
    },
    close() {
      this.display = false;
    },
    async unblock(account,k) {
      k.loading = true
      let result = await this.unblockAccount(this,account.userId)
      k.loading = false
      if(!result) return
      k.blockedAccounts = k.blockedAccounts.filter(a => a.userId !== account.userId);
      //k.$emit('unblock', account);
    },
    async unblockAccount (k,uid) {
      try {
          await k.$axios.post('user.php',{type:"unblockUser",userId:uid})
          return true
      } catch (e) {
          console.log(e.response)
          return false
      }
    }
  }
}
</script>

<style scoped>
.blocked-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0e26;
  z-index: 1000;
  overflow-y: auto;
  padding-bottom:115px ;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.top-bar {
  position: sticky;
  top: 0;
  background: rgba(10, 14, 38, 0.95);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.icon-button {
  position: absolute;
  left: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #e0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-button svg {
  width: 24px;
  height: 24px;
}

.icon-button:hover {
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
}

.page-title {
  color: #e0f7ff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.spacer {
  width: 0px;
  visibility: hidden;
}

.content {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  gap: 16px;
}

.empty-state svg {
  width: 60px;
  height: 60px;
  color: #94a3b8;
}

.empty-state p {
  color: #94a3b8;
  font-size: 16px;
  margin: 0;
}

/* Blocked List */
.blocked-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.blocked-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: rgba(30, 41, 59, 0.4);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 12px;
}

.blocked-username {
  color: #e0f7ff;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
}

.unblock-button {
  background: transparent;
  border: 1px solid rgba(0, 212, 255, 0.3);
  color: #00d4ff;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  font-family: inherit;
}

.unblock-button:hover {
  background: rgba(0, 212, 255, 0.15);
  border-color: #00d4ff;
}

@media (max-width: 480px) {
  .content {
    padding: 12px;
  }

  .blocked-item {
    padding: 12px;
  }

  .unblock-button {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>